import { CommonService } from './common.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../clientcfg';

export const LOTTO_COMBODIA = 1;
export const LOTTO_COMBO_VIP = 2;
export const LOTTO_COMBO_SILVER = 3;
export const LOTTO_COMBO_EXTRA = 4;
export const LOTTO_COMBO_GOLD = 5;

const api_glotteam = AppConfig.SERVER_URL + '/act/glotteam';
const api_glotmatch = AppConfig.SERVER_URL + '/act/glotmatch';
const api_glotcurmatch = AppConfig.SERVER_URL + '/act/glotcurmatch';
const api_glotresult = AppConfig.SERVER_URL + '/act/glotresult';
const api_glotresulthis = AppConfig.SERVER_URL + '/act/glotresulthis';
const api_glotresultadmin = AppConfig.SERVER_URL + '/act/glotresultadmin';
const api_svresult = AppConfig.SERVER_URL + '/act/svresult';
const api_svtime = AppConfig.SERVER_URL + '/act/svtime';
const api_chklogin = AppConfig.SERVER_URL + '/act/chklogin';
const api_savepass = AppConfig.SERVER_URL + '/act/chgpass';

@Injectable({
  providedIn: 'root'
})
export class LottoService {

  constructor(private http: HttpClient, private comAPI: CommonService) { }

  GetLottoTeam(): Observable<any> {
    return this.http.get<any>(api_glotteam);
  }

  GetLottoMatch(): Observable<any> {
    return this.http.get<any>(api_glotmatch);
  }

  GetLottoCurrentMatch(): Observable<any> {
    return this.http.get<any>(api_glotcurmatch);
  }

  GetLottoResult(matid: number): Observable<any> {
    return this.http.get<any>(api_glotresult + '?mtid=' + matid);
  }

  GetLottoResultHis(): Observable<any> {
    return this.http.get<any>(api_glotresulthis);
  }

  GetLottoResultAdmin(matid: number): Observable<any> {
    return this.http.get<any>(api_glotresultadmin + '?mtid=' + matid);
  }

  SaveResult(result: any): Observable<any> {
    return this.http.post<any>(api_svresult, result);
  }

  SaveTime(times: any): Observable<any> {
    return this.http.post<any>(api_svtime, times);
  }

  Login(userinfo: any): Observable<any> {
    return this.http.post<any>(api_chklogin, userinfo);
  }

  SavePass(uid: number, pass: string, token: string): Observable<any> {
    return this.http.get<any>(api_savepass + '?uid=' + uid + '&ps=' + pass + '&tk=' + token);
  }
}
